import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VSnackbar,{attrs:{"value":_vm.$store.state.success,"color":"primary","timeout":2000,"top":""},on:{"input":_vm.hideSuccess}},[_c(VIcon,{staticClass:"mr-3"},[_vm._v("mdi-check-circle-outline")]),_vm._v(" "+_vm._s(_vm.$store.state.success)+" "),_c(VBtn,{attrs:{"text":""},on:{"click":_vm.hideSuccess}},[_vm._v("OK")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }